/* Maison Alméa — menu à images (ordi, survol). 30/09 perf : sorti de sections/nautiya-menu-images.liquid, defer. */
(function(CS){
 (function almBoot(){
  if (document.readyState === 'loading' && (!document.getElementById('almk-inav') || (!(window.matchMedia && window.matchMedia('(min-width: 1100px)').matches) && document.getElementById('almea-render-barrier') && !document.getElementById('almea-pdp-pret')))) { setTimeout(almBoot, 20); return; } /* 30/09 perf mobile : menu d'ORDINATEUR → sur téléphone (fiche produit) il démarre après le 1er affichage */

(function () {
  var OPEN_DELAY = 70, CLOSE_DELAY = 200, MIN_WIDTH = 1100;
  var BASE_GAP = (parseFloat(CS && CS.getAttribute('data-gap')) || 26), BASE_SIZE = (parseFloat(CS && CS.getAttribute('data-size')) || 12);
  var CART_SVG = '<path d="M6 7.6h12l-1 11.4H7L6 7.6Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M9.3 9.3V6.7a2.7 2.7 0 0 1 5.4 0v2.6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>';
  var scrim = null, closeT = null, openT = null, current = null;

  var almMQ = window.matchMedia ? window.matchMedia('(min-width: ' + MIN_WIDTH + 'px)') : null;
  function isDesktop() { return almMQ ? almMQ.matches : window.innerWidth >= MIN_WIDTH; } /* 30/09 perf : matchMedia (window.innerWidth forçait un recalcul complet : 67 ms sur téléphone) */

  function getScrim() {
    if (scrim && scrim.parentNode) return scrim;
    scrim = document.querySelector('.alm-scrim');
    if (!scrim) { scrim = document.createElement('div'); scrim.className = 'alm-scrim'; document.body.appendChild(scrim); }
    return scrim;
  }

  function showShot(mega, key) {
    var shots = mega.querySelectorAll('.alm-mega-shot');
    var label = mega.querySelector('[data-alm-stage-label]');
    for (var i = 0; i < shots.length; i++) {
      var on = shots[i].getAttribute('data-alm-key') === key;
      shots[i].classList.toggle('is-on', on);
      if (on && label) label.textContent = shots[i].getAttribute('data-alm-title') || '';
    }
    var links = mega.querySelectorAll('.alm-mega-link');
    for (var j = 0; j < links.length; j++) {
      links[j].classList.toggle('is-current', links[j].getAttribute('data-alm-key') === key);
    }
  }
  function resetShot(mega) {
    var first = mega.querySelector('.alm-mega-shot');
    if (first) showShot(mega, first.getAttribute('data-alm-key'));
  }

  function openItem(item) {
    if (!isDesktop() || item.__almNoOpen || item.style.display === 'none') return;
    if (current && current !== item) closeItem(current);
    item.classList.add('is-open');
    var l = item.querySelector('.alm-inav-link');
    if (l) l.setAttribute('aria-expanded', 'true');
    /* 03/09 : remplace le :has() de alm-pdp-blanc.css (textes de l'en-tete en blanc panneau ouvert) */
    var hd = item.closest('.mz-header'); if (hd) hd.classList.add('alm-inav-panel-open');
    if (item.__mega) { item.__mega.classList.add('is-open'); resetShot(item.__mega); }
    getScrim().classList.add('is-on');
    current = item;
  }
  function closeItem(item) {
    if (!item) return;
    item.classList.remove('is-open');
    var l = item.querySelector('.alm-inav-link');
    if (l) l.setAttribute('aria-expanded', 'false');
    var hd2 = item.closest('.mz-header'); if (hd2 && !hd2.querySelector('.alm-inav-item--has-panel.is-open')) hd2.classList.remove('alm-inav-panel-open');
    if (item.__mega) item.__mega.classList.remove('is-open');
    if (current === item) current = null;
    setTimeout(function () {
      if (!document.querySelector('.alm-mega.is-open')) getScrim().classList.remove('is-on');
    }, 0);
  }
  function closeAll() {
    var open = document.querySelectorAll('.alm-inav-item--has-panel.is-open');
    for (var i = 0; i < open.length; i++) closeItem(open[i]);
  }
  function scheduleClose(item) {
    clearTimeout(openT); clearTimeout(closeT);
    closeT = setTimeout(function () { closeItem(item); }, CLOSE_DELAY);
  }

  function decorateActions() {
    var acts = document.querySelector('.mz-header .mz-actions');
    if (!acts) return;
    var cart = acts.querySelector('.mz-action--cart');
    if (!cart) return;
    var existing = cart.querySelector('.alm-cart-ico');
    /* 2026-08-25 : ce bloc SUPPRIMAIT l'icone du panier en dessous de 1100 px —
       d'ou le panier reduit a un simple chiffre sur mobile. L'icone est desormais
       rendue cote serveur dans sections/z-header-masazen.liquid, donc presente a
       toutes les largeurs. On ne la retire plus. */
    if (!isDesktop()) { return; }
    if (!existing) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'alm-cart-ico');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('aria-hidden', 'true');
      svg.innerHTML = CART_SVG;
      cart.insertBefore(svg, cart.firstChild);
      cart.setAttribute('aria-label', 'Warenkorb');
    }
    ['.mz-cart-count', '.mz-notif-dot'].forEach(function (sel) {
      var el = acts.querySelector(sel);
      if (!el) return;
      var upd = function () {
        var v = (el.textContent || '').trim();
        el.classList.toggle('alm-empty', v === '' || v === '0');
      };
      upd();
      if (!el.__almObs && window.MutationObserver) {
        el.__almObs = new MutationObserver(upd);
        el.__almObs.observe(el, { childList: true, characterData: true, subtree: true });
      }
    });
  }

  function fit(nav, side, logoRect, pad) {
    if (!nav || !isDesktop()) return;
    var list = nav.querySelector('.alm-inav-list');
    if (!list) return;
    var items = Array.prototype.slice.call(list.children);
    for (var a = 0; a < items.length; a++) items[a].style.display = '';
    list.style.gap = BASE_GAP + 'px';
    list.style.fontSize = BASE_SIZE + 'px';
    if (!logoRect || !logoRect.width) return;
    if (side === 'left' && logoRect.right <= nav.getBoundingClientRect().left) return; /* 22/10 (Lancelot : survol de Suspensions mort) : logo a gauche depuis l'en-tete du 19/10, le menu ne peut plus le chevaucher : on ne masque plus rien (openItem refusait les liens marques display:none alors qu'ils restaient visibles). RETOUR : supprimer cette ligne (copie : assets/bak-20261022-almea-inav.txt). */
    var over = side === 'left'
      ? function () { return nav.getBoundingClientRect().right > logoRect.left - pad; }
      : function () { return nav.getBoundingClientRect().left < logoRect.right + pad; };
    var gaps = [22, 18, 14, 10];
    for (var i = 0; i < gaps.length && over(); i++) list.style.gap = gaps[i] + 'px';
    var sizes = [11, 10];
    for (var j = 0; j < sizes.length && over(); j++) list.style.fontSize = sizes[j] + 'px';
    for (var k = (side === 'left' ? items.length - 1 : 0);
         over() && k >= 0 && k < items.length;
         k = (side === 'left' ? k - 1 : k + 1)) {
      if (items.filter(function (x) { return x.style.display !== 'none'; }).length <= 1) break;
      items[k].style.display = 'none';
    }
  }

  function layout() {
    if (!isDesktop()) { closeAll(); return; }
    var main = document.querySelector('.mz-header .mz-main');
    var logo = document.querySelector('.mz-header .mz-logo');
    var acts = document.querySelector('.mz-header .mz-actions');
    if (!main || !logo) return;
    var left = main.querySelector(':scope > nav.alm-inav--left');
    var right = main.querySelector(':scope > nav.alm-inav--right');
    if (right && acts) {
      var mr = main.getBoundingClientRect(), ar = acts.getBoundingClientRect();
      if (ar.width) right.style.right = Math.max(24, Math.round(mr.right - ar.left + 32)) + 'px';
    }
    /* 28/09 04h55 : on mesure le DESSIN du logo (svg/img), pas son cadre (307 px de large pour un logo de 95 px) :
       sinon le 3e lien du menu (Best-sellers) était masqué alors qu'il y avait la place. */
    var marque = logo.querySelector('svg, img');
    var lr = (marque && marque.getBoundingClientRect().width) ? marque.getBoundingClientRect() : logo.getBoundingClientRect();
    fit(left, 'left', lr, 28);
    fit(right, 'right', lr, 28);
  }

  function wireItem(item) {
    item.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      clearTimeout(closeT); clearTimeout(openT);
      openT = setTimeout(function () { openItem(item); }, OPEN_DELAY);
    });
    item.addEventListener('mouseleave', function () { if (isDesktop()) scheduleClose(item); });
    item.addEventListener('focusin', function () { if (!isDesktop()) return; clearTimeout(closeT); openItem(item); });
    item.addEventListener('focusout', function () {
      if (!isDesktop()) return;
      clearTimeout(closeT);
      closeT = setTimeout(function () {
        var m = item.__mega;
        if (!item.contains(document.activeElement) && !(m && m.contains(document.activeElement))) closeItem(item);
      }, CLOSE_DELAY);
    });
    var link = item.querySelector('.alm-inav-link');
    if (link) {
      link.addEventListener('keydown', function (e) {
        if (!isDesktop()) return;
        var isOpen = item.classList.contains('is-open');
        if (e.key === 'ArrowDown' || (e.key === 'Enter' && !isOpen)) {
          e.preventDefault(); openItem(item);
          var first = item.__mega && item.__mega.querySelector('.alm-mega-link');
          if (e.key === 'ArrowDown' && first) first.focus();
        }
      });
    }
    var mega = item.__mega;
    if (!mega) return;
    mega.addEventListener('mouseenter', function () { if (isDesktop()) clearTimeout(closeT); });
    mega.addEventListener('mouseleave', function () { if (isDesktop()) scheduleClose(item); });
    mega.addEventListener('focusin', function () { if (isDesktop()) clearTimeout(closeT); });
    mega.addEventListener('focusout', function () {
      if (!isDesktop()) return;
      clearTimeout(closeT);
      closeT = setTimeout(function () {
        if (!mega.contains(document.activeElement) && !item.contains(document.activeElement)) closeItem(item);
      }, CLOSE_DELAY);
    });
    var mlinks = mega.querySelectorAll('.alm-mega-link');
    for (var i = 0; i < mlinks.length; i++) {
      (function (a) {
        var act = function () { if (isDesktop()) showShot(mega, a.getAttribute('data-alm-key')); };
        a.addEventListener('mouseenter', act);
        a.addEventListener('focus', act);
      })(mlinks[i]);
    }
    var ul = mega.querySelector('.alm-mega-links');
    if (ul) ul.addEventListener('mouseleave', function () { if (isDesktop()) resetShot(mega); });
  }

  function wireGlobal() {
    if (document.documentElement.hasAttribute('data-alm-inav-global')) return;
    document.documentElement.setAttribute('data-alm-inav-global', '1');
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isDesktop()) return;
      var op = document.querySelector('.alm-inav-item--has-panel.is-open');
      if (!op) return;
      var l = op.querySelector('.alm-inav-link');
      op.__almNoOpen = true;
      closeItem(op);
      if (l) l.focus();
      setTimeout(function () { op.__almNoOpen = false; }, 300);
    });
    document.addEventListener('click', function (e) {
      if (!isDesktop()) return;
      if (e.target.closest && (e.target.closest('.alm-inav-item--has-panel') || e.target.closest('.alm-mega'))) return;
      closeAll();
    });
  }

  var HOST = document.currentScript ? document.currentScript.parentNode : null;

  function mount() {
    document.documentElement.classList.add('alm-inav-on');
    var header = document.querySelector('.mz-header');
    var main = header && header.querySelector('.mz-main');
    if (!main) return;

    var stale = main.querySelectorAll('nav.alm-inav');
    for (var i = 0; i < stale.length; i++) stale[i].parentNode.removeChild(stale[i]);
    var staleMega = header.querySelectorAll(':scope > .alm-mega');
    for (var j = 0; j < staleMega.length; j++) staleMega[j].parentNode.removeChild(staleMega[j]);

    var nav = (HOST && HOST.querySelector && HOST.querySelector('nav.alm-inav')) || document.querySelector('.shopify-section nav.alm-inav');
    if (!nav) return;

    var burger = main.querySelector('.mz-burger');
    if (burger && burger.nextSibling) main.insertBefore(nav, burger.nextSibling);
    else main.insertBefore(nav, main.firstChild);

    var list = nav.querySelector('.alm-inav-list');
    var items = Array.prototype.slice.call(list.children);
    if (items.length > 1) {
      var right = document.createElement('nav');
      right.className = 'alm-inav alm-inav--right';
      right.setAttribute('aria-label', 'Navigation principale (suite)');
      right.innerHTML = '<ul class="alm-inav-list"></ul>';
      var rl = right.querySelector('.alm-inav-list');
      var half = Math.ceil(items.length / 2);
      for (var k = half; k < items.length; k++) rl.appendChild(items[k]);
      main.appendChild(right);
    }

    var all = header.querySelectorAll('.alm-inav-item--has-panel');
    for (var n = 0; n < all.length; n++) {
      var it = all[n];
      var mg = it.querySelector('.alm-mega');
      if (mg) { header.appendChild(mg); it.__mega = mg; }
      wireItem(it);
    }
    wireGlobal();
    decorateActions();
    layout();
  }

  var rt = null;
  function relayout() {
    clearTimeout(rt);
    rt = setTimeout(function () { decorateActions(); layout(); }, 150);
  }

  mount();
  window.addEventListener('resize', relayout);
  window.addEventListener('load', relayout);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayout);
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e && e.target;
    if (sec && sec.querySelector && sec.querySelector('nav.alm-inav')) { HOST = sec; }
    setTimeout(mount, 0);
  });
})();

 })();
})(document.currentScript);
